import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router.js'
import './css/tailwind.css'
import './css/main.css'
import 'leaflet/dist/leaflet.css'

window.config = {
  BASEURL: process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000' : 'https://spkp.kkp.go.id/salmontrack',
  BASEURL_API1: process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000/api/v1' : 'https://spkp.kkp.go.id/salmontrack/api/v1',
  BASEURL_API2: process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000/api/v2' : 'https://spkp.kkp.go.id/salmontrack/api/v2'
}

createApp(App)
  .use(store)
  .use(router)
  .mount('#app')
